<template>
  <div>
    <h2 class="mb-4">Stock Patterns</h2>
    <div class="flex max-w-md font-semibold text-base bg-grey-lightest">
      <div class="flex-none w-1/2 sm:w-20 px-2 py-1 text-center sm:text-left">
        Ticker
      </div>
      <div class="flex-none w-1/2 sm:w-20 px-2 py-1 text-center sm:text-left">
        Pattern
      </div>
      <div class="flex-grow px-2 py-1 hidden sm:block">
        Notes
      </div>
      <div class="flex-none w-8 px-2 py-1 bg-white hidden sm:block"></div>
    </div>
    <div v-for="(pattern, index) in patterns" :key="pattern.id" :class="{'bg-grey-lighter': (index % 2 == 1)}" class="flex max-w-md text-base flex-wrap sm:flex-no-wrap">
      <div class="sm:flex flex-none w-1/2 sm:w-20 p-2 border-t-2 text-xl font-medium text-center items-center">
        {{ pattern.ticker }}
      </div>
      <div class="sm:flex flex-none items-center w-1/2 sm:w-20 p-1 border-t-2">
        <span class="flex flex-col text-center">
          <img :src="patternImage(pattern.pattern)" width="26" class="self-center ml-3 mr-3">
          <span>
            {{ pattern.pattern }}
          </span>
        </span>
      </div>
      <div :class="{'border-t-2': pattern.note}" class="flex-grow px-1 sm:px-3 py-3 mt-2 sm:mt-0 border-grey-lighter sm:border-grey-light sm:border-t-2">
        {{ pattern.note }}
      </div>
      <div class="flex flex-none bg-grey-lightest sm:bg-white border-0 sm:border-t-2 border-white w-8 px-3 sm:px-2 py-2 mt-2 sm:mt-0 items-center text-center text-grey hover:text-grey-darker cursor-pointer" @click="removePattern(pattern.id, index)">
        <i v-if="pattern.deleting" class="fas fa-sync fa-spin"></i>
        <i v-else class="fa fa-times"></i>
      </div>
    </div>
    <div class="flex justify-end pt-4">
      <button class="flex-no-shrink bg-blue-dark hover:bg-blue-darker border-blue-dark hover:border-blue-darker text-sm border-4 text-white py-1 px-2 rounded" type="button" @click="$router.push('/stock-pattern/create')">
        Create New Pattern
      </button>
    </div>
  </div>
</template>

<script>
import { api } from "arctic-vuejs-template";
export default {
  name: "pattern",
  data() {
    return {
      patterns: []
    };
  },
  beforeMount() {
    this.loadPatterns();
  },
  methods: {
    loadPatterns() {
      this.patterns = [];
      api.get("/pattern").then(response => {
        this.patterns = response.data;
      });
    },
    patternImage(pattern) {
      return (
        "/img/" +
        pattern
          .replace(/\W+/g, "_")
          .replace(/-$/g, "")
          .toLowerCase() +
        ".png"
      );
    },
    removePattern(id, index) {
      if (this.patterns[index].deleting) return;
      this.$set(this.patterns[index], "deleting", true);
      api
        .delete(`/pattern/${id}`)
        .then(() => this.$delete(this.patterns, index));
    }
  }
};
</script>

<style>
@media (min-width: 576px) {
  .sm\:w-20 {
    width: 5rem;
  }
}
</style>
